'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = AdminRoutes;

var _generalSettingsTpl = require('../admin/general-settings.tpl.html');

var _generalSettingsTpl2 = _interopRequireDefault(_generalSettingsTpl);

var _outgoingMailSettingsTpl = require('../admin/outgoing-mail-settings.tpl.html');

var _outgoingMailSettingsTpl2 = _interopRequireDefault(_outgoingMailSettingsTpl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-enable import/no-unresolved, import/default */

/*@ngInject*/
/*
 * Copyright © 2016-2018 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/* eslint-disable import/no-unresolved, import/default */

function AdminRoutes($stateProvider) {
    $stateProvider.state('home.settings', {
        url: '/settings',
        module: 'private',
        auth: ['SYS_ADMIN'],
        redirectTo: 'home.settings.general',
        ncyBreadcrumb: {
            label: '{"icon": "settings", "label": "admin.system-settings"}'
        }
    }).state('home.settings.general', {
        url: '/general',
        module: 'private',
        auth: ['SYS_ADMIN'],
        views: {
            "content@home": {
                templateUrl: _generalSettingsTpl2.default,
                controllerAs: 'vm',
                controller: 'AdminController'
            }
        },
        data: {
            key: 'general',
            pageTitle: 'admin.general-settings'
        },
        ncyBreadcrumb: {
            label: '{"icon": "settings_applications", "label": "admin.general"}'
        }
    }).state('home.settings.outgoing-mail', {
        url: '/outgoing-mail',
        module: 'private',
        auth: ['SYS_ADMIN'],
        views: {
            "content@home": {
                templateUrl: _outgoingMailSettingsTpl2.default,
                controllerAs: 'vm',
                controller: 'AdminController'
            }
        },
        data: {
            key: 'mail',
            pageTitle: 'admin.outgoing-mail-settings'
        },
        ncyBreadcrumb: {
            label: '{"icon": "mail", "label": "admin.outgoing-mail"}'
        }
    });
}


// WEBPACK FOOTER //
// ./src/app/admin/admin.routes.js